import { render, staticRenderFns } from "./PersonW9CR.vue?vue&type=template&id=2eeec6a8&scoped=true&"
import script from "./PersonW9CR.vue?vue&type=script&lang=ts&"
export * from "./PersonW9CR.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeec6a8",
  null
  
)

export default component.exports